
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';
import { Mail, Calendar, Phone } from 'lucide-react';

const ContactPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-noordblue-light py-16 px-6">
          <div className="container mx-auto">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Neem contact op
              </h1>
              <p className="text-lg text-gray-700">
                Benieuwd wat AI voor jouw bedrijf kan doen? Of wil je gewoon even sparren over de mogelijkheden? 
                Laat je gegevens achter en we nemen snel contact met je op.
              </p>
            </div>
          </div>
        </section>

        {/* Contact Form Section */}
        <section className="py-16 px-6">
          <div className="container mx-auto">
            <div className="grid md:grid-cols-2 gap-16">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Stuur ons een bericht
                </h2>
                <ContactForm />
              </div>
              
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Andere manieren om contact op te nemen
                </h2>
                
                <div className="space-y-8">
                  <div className="flex items-start gap-4">
                    <div className="bg-noordblue-light p-3 rounded-full">
                      <Calendar className="h-6 w-6 text-noordblue" />
                    </div>
                    <div>
                      <h3 className="text-lg font-medium text-gray-900 mb-1">
                        Plan een gesprek
                      </h3>
                      <p className="text-gray-700">
                        Liever direct een afspraak inplannen? Stuur een e-mail voor het plannen van een vrijblijvend kennismakingsgesprek.
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <div className="bg-noordblue-light p-3 rounded-full">
                      <Mail className="h-6 w-6 text-noordblue" />
                    </div>
                    <div>
                      <h3 className="text-lg font-medium text-gray-900 mb-1">
                        E-mail
                      </h3>
                      <p className="text-gray-700">
                        Stuur ons direct een e-mail op{' '}
                        <a href="mailto:info@noord-ai.nl" className="text-noordblue hover:underline">
                          info@noord-ai.nl
                        </a>
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <div className="bg-noordblue-light p-3 rounded-full">
                      <Phone className="h-6 w-6 text-noordblue" />
                    </div>
                    <div>
                      <h3 className="text-lg font-medium text-gray-900 mb-1">
                        Bedrijfsgegevens
                      </h3>
                      <p className="text-gray-700">
                        Noord AI<br />
                        KvK: 87456613<br />
                        Regio: Groningen, Drenthe en Friesland
                      </p>
                    </div>
                  </div>
                </div>
                
                <div className="mt-12 bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-lg font-medium text-gray-900 mb-3">
                    Over onze diensten
                  </h3>
                  <p className="text-gray-700 mb-4">
                    Bij Noord AI bieden we maatwerk-oplossingen die passen bij jouw bedrijf. Wij helpen je bij elke stap van het proces, van de eerste verkenning tot implementatie en ondersteuning.
                  </p>
                  <a 
                    href="/diensten" 
                    className="text-noordblue hover:underline font-medium"
                  >
                    Bekijk al onze diensten →
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
